import React, { useMemo } from 'react';
import { useCarrierQuery } from 'src/services/carrier';
import { useAllCountriesListQuery, useAllCountryGroupsQuery } from 'src/services/countries';
import Badge from '../Badge/Badge';

type ReferenceFilterBadgeProps = {
  type: string;
  value: string;
  preLabel: string;
  onRemove: () => void;
  className?: string;
};

const ReferenceFilterBadge: React.FC<ReferenceFilterBadgeProps> = ({ type, value, preLabel, onRemove, className }) => {
  const carriers = useCarrierQuery({ page: 1, size: 100 });
  const countries = useAllCountriesListQuery();
  const groups = useAllCountryGroupsQuery({});

  const label = useMemo(() => {
    if (type === 'carrier') {
      return carriers.data?.items?.find(c => String(c.id) === value)?.name ?? value;
    }
    if (type === 'country') {
      return (countries.data ?? []).find(c => String(c.id) === value)?.name ?? value;
    }
    if (type === 'country_group') {
      return groups.data?.items?.find(g => String(g.id) === value)?.name ?? value;
    }
    return value;
  }, [type, value, carriers.data, countries.data, groups.data]);

  return (
    <Badge className={className} preLabel={preLabel} label={label} expanded icon="deleteCircle" onClick={onRemove} />
  );
};

export default ReferenceFilterBadge;
